import { shiftEditorViewState } from "..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateStartTime", function updateStartTime(startTime: Moment) {
    if (startTime) {
        shiftEditorViewState().timeOffStartTime = startTime.clone();
    }
});
